import React, { useRef } from "react";
import { Formik } from "formik";
import { Button, FormGroup, Label, Row, Col } from "reactstrap";
import { cloneDeep } from 'lodash';
import * as Yup from "yup";
import CoveredEntity from "components/CoveredEntity";

const validationSchema = Yup.object({
  coveredEntityName: Yup.string().required("Please select covered entity"),
});

const SearchContainer = ({ handleUpdateEntity, onSearch, onReset, initialValue, onCoverdEntityChange }) => {

  const formikRef = useRef();

  const handleSubmit = async (val, actions) => {
    const { setSubmitting } = actions;
    const values = cloneDeep(val);
    await onSearch(values);
    setSubmitting(false);
  };

  const handleCoverdEntityChange = async (
    value,
    setFieldValue,
    coveredEnty
  ) => {
    handleUpdateEntity(coveredEnty)
    setFieldValue("coveredEntityName", value);
  };

  return (
    <>
      <Formik
        innerRef={formikRef}
        onSubmit={handleSubmit}
        initialValues={initialValue}
        validationSchema={validationSchema}
        children={(props) => {
          const { isSubmitting, handleSubmit, resetForm, setFieldValue } =
            props;
          return (
            <div>
              <h5 className="f-15 text-primary font-weight-700">
                Service Locations
              </h5>
              <Row sm={5}>
                <Col md={2} sm={3} xs={6}>
                  {" "}
                  <FormGroup>
                    <Label for="coveredEntityID">Covered Entity</Label>
                    <CoveredEntity
                      name="coveredEntityName"
                      onChange={(value, coveredEnty) =>
                        handleCoverdEntityChange(value, setFieldValue, coveredEnty)
                      }
                    />
                  </FormGroup>
                </Col>

                <Col md="auto" className="pt-4 mt-1">
                  <Label>{""}</Label>
                  <Button
                    disabled={isSubmitting}
                    onClick={handleSubmit}
                    color="primary"
                    className="ms-3"
                  >
                    Search
                  </Button>
                  <Button
                    color="primary"
                    onClick={() => {
                      resetForm();
                      onReset();
                    }}
                  >
                    Reset
                  </Button>
                </Col>
              </Row>
            </div>
          );
        }}
      ></Formik>
    </>
  );
};

export default SearchContainer;